import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const getMemberships = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const redeemReferralReward = async (membershipId: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships/redeem-referral', { params: { membershipId } })
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const getMyActiveMembership = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships/my-active')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const getBillingPortalUrl = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships/billing-portal')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const getMyOffers = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships/my-offers')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const createMembershipCheckout = async (membershipId: string, priceType: string, offerId?: string, dailyGrindAddon?: boolean): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/memberships/checkout', { membershipId, priceType, offerId, dailyGrindAddon })
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const triggerMembershipSync = (): void => {
   axiosSecure.post('/memberships/sync').catch(() => {});
};

export const addDgeAddon = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/memberships/dge-addon')
      .then((response) => handleResponse(response))
      .catch(handleError);
};
